import {ChecklistRepository} from '../repository/ChecklistRepository';

export class DeleteChecklistUseCase {
  constructor (private checklistRepository: ChecklistRepository) {}

  async execute (id: number): Promise<void> {
    return this.checklistRepository.remove(id);
  }
}
